import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {finalize,tap} from 'rxjs/operators';
import swal from 'sweetalert2';
import {SpinnerService} from '../services/spinner.service';
@Injectable()
export class AuthInterceptor  implements HttpInterceptor {
  count = 0;
  constructor(private spinnerService:SpinnerService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
    this.spinnerService.show();
    this.count++;
    if (currentUser && currentUser.vid) {
      if(request.url.indexOf('/api/dashboard/config') == -1 && request.url.indexOf('/api/dashboard/form/import') == -1 && request.url.indexOf('/api/dashboard/globalform/import') == -1 && request.url.indexOf('dashboard/form/create') == -1 && request.url.indexOf('dashboard/globalform/create') == -1 && request.url.indexOf('/form/publish') == -1)
      {
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            vid: `${currentUser.vid}`,
            'X-VV-REQUEST': 'X-VV-REQUEST'
          }
        });
      }
      else if(request.url.indexOf('/api/dashboard/config') !== -1 && request.method !== 'post')
      {
        request = request.clone({
          setHeaders: {
            vid: `${currentUser.vid}`,
            'X-VV-REQUEST': 'X-VV-REQUEST'
          }
        });
      }
    }else{
        request = request.clone({
            setHeaders: {
              'Content-Type': 'application/json',
              'X-VV-REQUEST': 'X-VV-REQUEST'
            }
          });
    }

    return next.handle(request).pipe( tap(() => {
      //this.spinnerService.hide();
    },
      (err: any) => {
        //this.redirectToLogin();
                this.spinnerService.hide();
      if (err instanceof HttpErrorResponse) {
        if(err.url.indexOf('dashboard/login') !== -1)
        {
          if(err.status ==400)
            this.showMessage("error","Invalid username/password");
          else  
            this.showMessage("error","Sorry, we hit a snag. Will be back soon");
        }
        else if(err.url.indexOf('dashboard/sendinvite') !== -1)
        {
          if(err.status ==400)
            this.showMessage("error","Add User failed. Contact admin to add this user");
          else  
          this.showMessage("error",err.message);
        }
        else if(err.url.indexOf('dashboard/logout') !== -1)
        {
          this.redirectToLogin();
        }
        else if((err.url.indexOf('dashboard/forgotpassword') === -1))
        {
          if (err.status === 401) {
            this.redirectToLogin();
          }
          else if (err.status === 500){
              console.log("500 error" + err);
              this.showMessage("error","Error reaching server.Try again!");
          }
          else if (err.status === 400){
            this.showMessage("error",err.message);
        }
          else
          {
              console.log(""+err.status + err);
              this.showMessage("error","Error in processing the action.Try again!");
          }
      }
      else{
        swal({
          title: 'Instructions to reset Vector Viewer credentials is sent to your email',
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success"
      }).catch(swal.noop)
      }
      }
    }), finalize(() => {
      this.count--;
      if ( this.count == 0 )
      {
        this.spinnerService.hide();
        
      }
  }));
  }
  redirectToLogin() {
    sessionStorage.clear();
    window.location.href = "#/auth/login?refresh=1";
  }
  showMessage(type,message) {        
    if (type == 'success') {
        swal({
            title: message,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success"
        }).catch(swal.noop)

    } else if (type == 'info') {
      swal({
          title: message,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info"
      }).catch(swal.noop)
    }else if (type == 'warning') {
      swal({
          title: message,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning"
      }).catch(swal.noop)
    }   
    else if (type == 'error') {
      swal({
          title: message,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-danger"
      }).catch(swal.noop)
    }   
  }
}